// ThemeContext.js

import {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";

export enum Theme {
  LIGHT = "light",
  DARK = "dark",
}
const ThemeContext = createContext({
  theme: Theme.DARK,
  selectTheme: (arg: Theme) => {},
});

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState(Theme.DARK);

  const selectTheme = (arg: Theme) => {
    setTheme(arg);
  };

  useEffect(() => {
    if (theme === Theme.LIGHT) {
      document.documentElement.classList.toggle("dark", false);
    } else {
      document.documentElement.classList.toggle("dark", true);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, selectTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};
